import React, { Component } from 'react';
import { Button, FormGroup, Input, Label } from "reactstrap";
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import classes from './Login.module.scss';
import Popup from '../../Popup/Popup';  

export default class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: "",
      password: "",
      showPopup: true
    };
  }

  togglePopup = () => {  
    this.setState({  
         showPopup: !this.state.showPopup  
    });  
  } 

  componentDidMount() {
    // this.test();
  }

  // async test() {
  //   try {
  //     const response = await axios('api/testapi', {
  //       method: 'GET',
  //       withCredentials: true

  //     });
  //     const responseData = response.data;
  //     console.log(responseData);
  //   } catch (ex) {
  //     console.log('not authenticated')
  //   }
  // }

  validateForm() {
    return this.state.username.length > 0 && this.state.password.length > 0;
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    //authenticate HERE

    if (this.validateForm()) {

      this.props.setAuth(true);

      /*
      try {
        let response = await axios('login', {
          method: 'POST',
          data: {
            "email": this.state.username,
            "password": this.state.password
          },
          withCredentials: true

        });

        const responseData = response.data
        if (responseData.success) {
          console.log(responseData);
          this.props.setAuth(true);
        }

      } catch (ex) {
        console.log('errore API login');

      }
      */
    }
  }

  render() {

    if (this.props.auth === true) {
      return <Redirect to='/' />
    }

    return (
      <div>
      <div className={classes.externalContainer}>
        <form className={classes.form} onSubmit={this.handleSubmit}>
          <FormGroup>
            <Label className={classes.label}>Email or Username</Label>
            <Input
              autoFocus
              name="username"
              type="text"
              value={this.state.email}
              onChange={this.handleChange}
            />
          </FormGroup>
          <FormGroup>
            <Label className={classes.label}>Password</Label>
            <Input
              name="password"
              value={this.state.password}
              onChange={this.handleChange}
              type="password"
            />
          </FormGroup>
          <Button
            block
            size="lg"
            //disabled={!this.validateForm()}
            type="submit"
          >
            Login
          </Button>
        </form>
      </div>
      {this.state.showPopup ?  
        <Popup  
                text='Insert any username and password' 
                  closePopup={this.togglePopup}  
        />  
        : null  
        }  
        </div>
    );
  }
}

Login.propTypes = {
  setAuth: PropTypes.func.isRequired, //function that allow to return the authentication
  auth: PropTypes.bool.isRequired
}
